// ../../node_modules/@archetype-themes/next/sections/slideshow/src/index.js
theme.Slideshow = function () {
  var classes = {
    animateOut: "animate-out",
    isPaused: "is-paused",
    isActive: "is-active"
  };
  var selectors = {
    allSlides: ".slideshow__slide",
    currentSlide: ".is-selected",
    wrapper: ".slideshow-wrapper",
    pauseButton: ".slideshow__pause"
  };
  var productSelectors = {
    thumb: ".product__thumb-item:not(.hide)",
    links: ".product__thumb-item:not(.hide) a",
    arrow: ".product__thumb-arrow"
  };
  var defaults = {
    adaptiveHeight: false,
    autoPlay: false,
    avoidReflow: false,
    // custom by Archetype
    childNav: null,
    // element. Custom by Archetype instead of asNavFor
    childNavScroller: null,
    // element
    childVertical: false,
    dragThreshold: 7,
    fade: false,
    friction: 0.8,
    initialIndex: 0,
    pageDots: false,
    pauseAutoPlayOnHover: false,
    prevNextButtons: false,
    rightToLeft: theme.config.rtl,
    selectedAttraction: 0.14,
    setGallerySize: true,
    wrapAround: true
  };
  function slideshow(el, args) {
    this.el = el;
    this.args = Object.assign({}, defaults, args);
    this.args.on = {
      ready: this.init.bind(this),
      change: this.slideChange.bind(this),
      settle: this.afterChange.bind(this)
    };
    if (this.args.childNav) {
      this.childNavEls = this.args.childNav.querySelectorAll(productSelectors.thumb);
      this.childNavLinks = this.args.childNav.querySelectorAll(productSelectors.links);
      this.arrows = this.args.childNav.querySelectorAll(productSelectors.arrow);
      if (this.childNavLinks.length) {
        this.initChildNav();
      }
    }
    if (this.args.avoidReflow) {
      avoidReflow(el);
    }
    this.slideshow = new Flickity(el, this.args);
    if (el.dataset.zoom && el.dataset.zoom === "true") {
      this.slideshow.on("dragStart", () => {
        this.slideshow.slider.style.pointerEvents = "none";
        if (this.slideshow.options.fade) {
          this.slideshow.slider.querySelector(".is-selected").style.pointerEvents = "none";
        }
      });
      this.slideshow.on("dragEnd", () => {
        this.slideshow.slider.style.pointerEvents = "auto";
        if (this.slideshow.options.fade) {
          this.slideshow.slider.querySelector(".is-selected").style.pointerEvents = "auto";
        }
      });
    }
    if (this.args.autoPlay) {
      var wrapper = el.closest(selectors.wrapper);
      this.pauseBtn = wrapper.querySelector(selectors.pauseButton);
      if (this.pauseBtn) {
        this.pauseBtn.addEventListener("click", this._togglePause.bind(this));
      }
    }
    window.on("resize", theme.utils.debounce(300, function () {
      this.resize();
    }.bind(this)));
    function avoidReflow(el2) {
      if (!el2.id)
        return;
      var firstChild = el2.firstChild;
      while (firstChild != null && firstChild.nodeType == 3) {
        firstChild = firstChild.nextSibling;
      }
      var style = document.createElement("style");
      style.innerHTML = `#${el2.id} .flickity-viewport{height:${firstChild.offsetHeight}px}`;
      document.head.appendChild(style);
    }
  }
  slideshow.prototype = Object.assign({}, slideshow.prototype, {
    init: function (el) {
      this.currentSlide = this.el.querySelector(selectors.currentSlide);
      if (this.args.callbacks && this.args.callbacks.onInit) {
        if (typeof this.args.callbacks.onInit === "function") {
          this.args.callbacks.onInit(this.currentSlide);
        }
      }
      if (window.AOS) {
        AOS.refresh();
      }
    },
    slideChange: function (index) {
      if (this.args.fade && this.currentSlide) {
        this.currentSlide.classList.add(classes.animateOut);
        this.currentSlide.addEventListener("transitionend", function () {
          this.currentSlide.classList.remove(classes.animateOut);
        }.bind(this));
      }
      if (this.args.childNav) {
        this.childNavGoTo(index);
      }
      if (this.args.callbacks && this.args.callbacks.onChange) {
        if (typeof this.args.callbacks.onChange === "function") {
          this.args.callbacks.onChange(index);
        }
      }
      if (this.arrows && this.arrows.length) {
        this.arrows[0].classList.toggle("hide", index === 0);
        this.arrows[1].classList.toggle("hide", index === this.childNavLinks.length - 1);
      }
    },
    afterChange: function (index) {
      if (this.args.fade) {
        this.el.querySelectorAll(selectors.allSlides).forEach((slide) => {
          slide.classList.remove(classes.animateOut);
        });
      }
      this.currentSlide = this.el.querySelector(selectors.currentSlide);
      if (this.args.childNav) {
        this.childNavGoTo(this.slideshow.selectedIndex);
      }
    },
    destroy: function () {
      if (this.args.childNav && this.childNavLinks.length) {
        this.childNavLinks.forEach((a) => {
          a.classList.remove(classes.isActive);
        });
      }
      this.slideshow.destroy();
    },
    reposition: function () {
      this.slideshow.reposition();
    },
    _togglePause: function () {
      if (this.pauseBtn.classList.contains(classes.isPaused)) {
        this.pauseBtn.classList.remove(classes.isPaused);
        this.slideshow.playPlayer();
      } else {
        this.pauseBtn.classList.add(classes.isPaused);
        this.slideshow.pausePlayer();
      }
    },
    resize: function () {
      this.slideshow.resize();
    },
    play: function () {
      this.slideshow.playPlayer();
    },
    pause: function () {
      this.slideshow.pausePlayer();
    },
    goToSlide: function (i) {
      this.slideshow.select(i);
    },
    setDraggable: function (enable) {
      this.slideshow.options.draggable = enable;
      this.slideshow.updateDraggable();
    },
    initChildNav: function () {
      this.childNavLinks[this.args.initialIndex].classList.add("is-active");
      this.childNavLinks.forEach((link, i) => {
        link.setAttribute("data-index", i);
        link.addEventListener("click", function (evt) {
          evt.preventDefault();
          this.goToSlide(this.getChildIndex(evt.currentTarget));
        }.bind(this));
        link.addEventListener("focus", function (evt) {
          this.goToSlide(this.getChildIndex(evt.currentTarget));
        }.bind(this));
        link.addEventListener("keydown", function (evt) {
          if (evt.keyCode === 13) {
            this.goToSlide(this.getChildIndex(evt.currentTarget));
          }
        }.bind(this));
      });
      if (this.arrows.length) {
        this.arrows.forEach((arrow) => {
          arrow.addEventListener("click", this.arrowClick.bind(this));
        });
        ;
      }
    },
    getChildIndex: function (target) {
      return Number.parseInt(target.dataset.index);
    },
    childNavGoTo: function (index) {
      this.childNavLinks.forEach((a) => {
        a.blur();
        a.classList.remove(classes.isActive);
      });
      var el = this.childNavLinks[index];
      el.classList.add(classes.isActive);
      if (!this.args.childNavScroller) {
        return;
      }
      if (this.args.childVertical) {
        var elTop = el.offsetTop;
        this.args.childNavScroller.scrollTop = elTop - 100;
      } else {
        var elLeft = el.offsetLeft;
        this.args.childNavScroller.scrollLeft = elLeft - 100;
      }
    },
    arrowClick: function (evt) {
      if (evt.currentTarget.classList.contains("product__thumb-arrow--prev")) {
        this.slideshow.previous();
      } else {
        this.slideshow.next();
      }
    }
  });
  return slideshow;
}();
var SlideshowSection = class extends HTMLElement {
  constructor() {
    super();
    theme.SlideshowSection = function () {
      var selectors = {
        parallaxContainer: ".parallax-container"
      };
      function SlideshowSection4(container) {
        this.container = container.querySelector('[data-section-type="slideshow-section"]');
        var sectionId = this.container.getAttribute("data-section-id");
        this.slideshow = container.querySelector(`#Slideshow-${sectionId}`);
        this.namespace = `.${sectionId}`;
        this.initialIndex = 0;
        if (!this.slideshow) {
          return;
        }
        var sectionEl = container.parentElement;
        var sectionIndex = [].indexOf.call(sectionEl.parentElement.children, sectionEl);
        if (sectionIndex === 0) {
          this.init();
        } else {
          theme.initWhenVisible({
            element: this.container,
            callback: this.init.bind(this)
          });
        }
      }
      SlideshowSection4.prototype = Object.assign({}, SlideshowSection4.prototype, {
        init: function () {
          var slides = this.slideshow.querySelectorAll(".slideshow__slide");
          this.slideshow.classList.remove("loading", "loading--delayed");
          this.slideshow.classList.add("loaded");
          if (slides.length > 1) {
            var sliderArgs = {
              prevNextButtons: this.slideshow.hasAttribute("data-arrows"),
              pageDots: this.slideshow.hasAttribute("data-dots"),
              fade: true,
              setGallerySize: false,
              initialIndex: this.initialIndex,
              autoPlay: this.slideshow.dataset.autoplay === "true" ? Number.parseInt(this.slideshow.dataset.speed) : false
            };
            this.flickity = new theme.Slideshow(this.slideshow, sliderArgs);
          } else {
            slides[0].classList.add("is-selected");
          }
        },
        forceReload: function () {
          this.onUnload();
          this.init();
        },
        onUnload: function () {
          if (this.flickity && typeof this.flickity.destroy === "function") {
            this.flickity.destroy();
          }
        },
        onDeselect: function () {
          if (this.flickity && typeof this.flickity.play === "function") {
            this.flickity.play();
          }
        },
        onBlockSelect: function (evt) {
          var slide = this.slideshow.querySelector(`.slideshow__slide--${evt.detail.blockId}`);
          var index = Number.parseInt(slide.dataset.index);
          if (this.flickity && typeof this.flickity.pause === "function") {
            this.flickity.goToSlide(index);
            this.flickity.pause();
          } else {
            this.initialIndex = index;
            setTimeout(function () {
              if (this.flickity && typeof this.flickity.pause === "function") {
                this.flickity.pause();
              }
            }.bind(this), 1e3);
          }
        },
        onBlockDeselect: function () {
          if (this.flickity && typeof this.flickity.play === "function") {
            if (this.flickity.args.autoPlay) {
              this.flickity.play();
            }
          }
        }
      });
      return SlideshowSection4;
    }();
  }
  connectedCallback() {
    this.SlideshowSection = new theme.SlideshowSection(this);
  }
  disconnectedCallback() {
    this.SlideshowSection.onUnload();
  }
};
if (!customElements.get("slideshow-section")) {
  customElements.define("slideshow-section", SlideshowSection);
}

// ../../node_modules/@archetype-themes/next/sections/background-image-text/src/scripts/index.js
var BackgroundImage = class extends HTMLElement {
  constructor() {
    super();
    this.el = this.querySelector('[data-section-type="background-image"]');
    this.sectionId = this.el.dataset.sectionId;
    theme.initWhenVisible({
      element: this.el,
      callback: this.init.bind(this)
    });
  }
  init() {
    this.el.classList.remove("loading", "loading--delayed");
    this.el.classList.add("loaded");
  }
};
if (!customElements.get("background-image")) {
  customElements.define("background-image", BackgroundImage);
}

// ../../node_modules/@archetype-themes/next/sections/faq/src/scripts/index.js
var FAQ = class extends HTMLElement {
  constructor() {
    super();
    theme.collapsibles = function () {
      var selectors = {
        trigger: ".collapsible-trigger",
        module: ".collapsible-content",
        moduleInner: ".collapsible-content__inner",
        tabs: ".collapsible-trigger--tab"
      };
      var classes = {
        hide: "hide",
        open: "is-open",
        autoHeight: "collapsible--auto-height",
        tabs: "collapsible-trigger--tab"
      };
      var namespace = ".collapsible";
      var isTransitioning = false;
      function init(scope) {
        var el = scope ? scope : document;
        el.querySelectorAll(selectors.trigger).forEach((trigger) => {
          var state = trigger.classList.contains(classes.open);
          trigger.setAttribute("aria-expanded", state);
          trigger.off(`click${namespace}`);
          trigger.on(`click${namespace}`, toggle);
        });
      }
      function toggle(evt) {
        if (isTransitioning) {
          return;
        }
        isTransitioning = true;
        var el = evt.currentTarget;
        var isOpen = el.classList.contains(classes.open);
        var isTab = el.classList.contains(classes.tabs);
        var moduleId = el.getAttribute("aria-controls");
        var container = document.getElementById(moduleId);
        if (!moduleId) {
          moduleId = el.dataset.controls;
        }
        if (!moduleId) {
          return;
        }
        if (!container) {
          var multipleMatches = document.querySelectorAll('[data-id="' + moduleId + '"]');
          if (multipleMatches.length > 0) {
            container = el.parentNode.querySelector('[data-id="' + moduleId + '"]');
          }
        }
        if (!container) {
          isTransitioning = false;
          return;
        }
        var height = container.querySelector(selectors.moduleInner).offsetHeight;
        var isAutoHeight = container.classList.contains(classes.autoHeight);
        var parentCollapsibleEl = container.parentNode.closest(selectors.module);
        var childHeight = height;
        if (isTab) {
          if (isOpen) {
            isTransitioning = false;
            return;
          }
          var newModule;
          document.querySelectorAll(selectors.tabs + '[data-id="' + el.dataset.id + '"]').forEach((el2) => {
            el2.classList.remove(classes.open);
            newModule = document.querySelector(`#${el2.getAttribute("aria-controls")}`);
            setTransitionHeight(newModule, 0, true);
          });
        }
        if (isOpen && isAutoHeight) {
          setTimeout(function () {
            height = 0;
            setTransitionHeight(container, height, isOpen, isAutoHeight);
          }, 0);
        }
        if (isOpen && !isAutoHeight) {
          height = 0;
        }
        el.setAttribute("aria-expanded", !isOpen);
        if (isOpen) {
          el.classList.remove(classes.open);
        } else {
          el.classList.add(classes.open);
        }
        setTransitionHeight(container, height, isOpen, isAutoHeight);
        if (parentCollapsibleEl) {
          var parentHeight = parentCollapsibleEl.style.height;
          if (isOpen && parentHeight === "auto") {
            childHeight = 0;
          }
          var totalHeight = isOpen ? parentCollapsibleEl.offsetHeight - childHeight : height + parentCollapsibleEl.offsetHeight;
          setTransitionHeight(parentCollapsibleEl, totalHeight, false, false);
        }
        if (window.SPR) {
          var btn = container.querySelector(".spr-summary-actions-newreview");
          if (!btn) {
            return;
          }
          btn.off(`click${namespace}`);
          btn.on(`click${namespace}`, function () {
            height = container.querySelector(selectors.moduleInner).offsetHeight;
            setTransitionHeight(container, height, isOpen, isAutoHeight);
          });
        }
      }
      function setTransitionHeight(container, height, isOpen, isAutoHeight) {
        container.classList.remove(classes.hide);
        theme.utils.prepareTransition(container, function () {
          container.style.height = height + "px";
          if (isOpen) {
            container.classList.remove(classes.open);
          } else {
            container.classList.add(classes.open);
          }
        });
        if (!isOpen && isAutoHeight) {
          var o = container;
          window.setTimeout(function () {
            o.css("height", "auto");
            isTransitioning = false;
          }, 500);
        } else {
          isTransitioning = false;
        }
      }
      return {
        init
      };
    }();
  }
  connectedCallback() {
    theme.collapsibles.init(this);
  }
};
if (!customElements.get("collapsible-elements")) {
  customElements.define("collapsible-elements", FAQ);
}

// ../../node_modules/@archetype-themes/next/sections/image-compare/src/scripts/index.js
var ImageCompare = class extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.sectionId = this.dataset.sectionId;
    this.button = this.querySelector("[data-button]");
    this.draggableContainer = this.querySelector("[data-draggable]");
    this.primaryImage = this.querySelector("[data-primary-image]");
    this.secondaryImage = this.querySelector("[data-secondary-image]");
    this.calculateSizes();
    this.active = false;
    this.currentX = 0;
    this.initialX = 0;
    this.xOffset = 0;
    this.buttonOffset = this.button.offsetWidth / 2;
    this.el.addEventListener("touchstart", this.dragStart, false);
    this.el.addEventListener("touchend", this.dragEnd, false);
    this.el.addEventListener("touchmove", this.drag, false);
    this.el.addEventListener("mousedown", this.dragStart, false);
    this.el.addEventListener("mouseup", this.dragEnd, false);
    this.el.addEventListener("mousemove", this.drag, false);
    window.on("resize", theme.utils.debounce(250, () => {
      this.calculateSizes(true);
    }));
    document.addEventListener("shopify:section:load", (event) => {
      if (event.detail.sectionId === this.sectionId && this.primaryImage !== null) {
        this.calculateSizes();
      }
    });
  }
  calculateSizes(hasResized = false) {
    this.active = false;
    this.currentX = 0;
    this.initialX = 0;
    this.xOffset = 0;
    this.buttonOffset = this.button.offsetWidth / 2;
    this.elWidth = this.el.offsetWidth;
    this.button.style.transform = `translate(-${this.buttonOffset}px, -50%)`;
    if (this.primaryImage) {
      this.primaryImage.style.width = `${this.elWidth}px`;
    }
    if (hasResized)
      this.draggableContainer.style.width = `${this.elWidth / 2}px`;
  }
  dragStart(e) {
    if (e.type === "touchstart") {
      this.initialX = e.touches[0].clientX - this.xOffset;
    } else {
      this.initialX = e.clientX - this.xOffset;
    }
    if (e.target === this.button) {
      this.active = true;
    }
  }
  dragEnd(e) {
    this.initialX = this.currentX;
    this.active = false;
  }
  drag(e) {
    if (this.active) {
      e.preventDefault();
      if (e.type === "touchmove") {
        this.currentX = e.touches[0].clientX - this.initialX;
      } else {
        this.currentX = e.clientX - this.initialX;
      }
      this.xOffset = this.currentX;
      this.setTranslate(this.currentX, this.button);
    }
  }
  setTranslate(xPos, el) {
    let newXpos = xPos - this.buttonOffset;
    let newVal = this.elWidth / 2 + xPos;
    const boundaryPadding = 50;
    const XposMin = (this.elWidth / 2 + this.buttonOffset) * -1;
    const XposMax = this.elWidth / 2 - this.buttonOffset;
    if (newXpos < XposMin + boundaryPadding) {
      newXpos = XposMin + boundaryPadding;
      newVal = boundaryPadding;
    } else if (newXpos > XposMax - boundaryPadding) {
      newXpos = XposMax - boundaryPadding;
      newVal = this.elWidth - boundaryPadding;
    }
    el.style.transform = `translate(${newXpos}px, -50%)`;
    this.draggableContainer.style.width = `${newVal}px`;
  }
};
if (!customElements.get("image-compare")) {
  customElements.define("image-compare", ImageCompare);
}

// ../../node_modules/@archetype-themes/next/sections/countdown/src/scripts/index.js
var CountdownTimer = class extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.display = this.querySelector("[data-time-display]");
    this.block = this.closest(".countdown__block--timer");
    this.year = this.el.dataset.year;
    this.month = this.el.dataset.month;
    this.day = this.el.dataset.day;
    this.hour = this.el.dataset.hour;
    this.minute = this.el.dataset.minute;
    this.daysPlaceholder = this.querySelector("[date-days-placeholder]");
    this.hoursPlaceholder = this.querySelector("[date-hours-placeholder]");
    this.minutesPlaceholder = this.querySelector("[date-minutes-placeholder]");
    this.secondsPlaceholder = this.querySelector("[date-seconds-placeholder]");
    this.messagePlaceholder = this.querySelector("[data-message-placeholder]");
    this.hideTimerOnComplete = this.el.dataset.hideTimer;
    this.completeMessage = this.el.dataset.completeMessage;
    this.timerComplete = false;
    this.init();
  }
  init() {
    setInterval(() => {
      if (!this.timerComplete) {
        this._calculate();
      }
    }, 1e3);
  }
  _calculate() {
    const timeDifference = +(/* @__PURE__ */ new Date(`${this.month}/${this.day}/${this.year} ${this.hour}:${this.minute}:00`)).getTime() - +(/* @__PURE__ */ new Date()).getTime();
    if (timeDifference > 0) {
      const intervals = {
        days: Math.floor(timeDifference / (1e3 * 60 * 60 * 24)),
        hours: Math.floor(timeDifference / (1e3 * 60 * 60) % 24),
        minutes: Math.floor(timeDifference / 1e3 / 60 % 60),
        seconds: Math.floor(timeDifference / 1e3 % 60)
      };
      this.daysPlaceholder.innerHTML = intervals.days;
      this.hoursPlaceholder.innerHTML = intervals.hours;
      this.minutesPlaceholder.innerHTML = intervals.minutes;
      this.secondsPlaceholder.innerHTML = intervals.seconds;
    } else {
      if (this.completeMessage && this.messagePlaceholder) {
        this.messagePlaceholder.classList.add("countdown__timer-message--visible");
      }
      if (this.hideTimerOnComplete === "true") {
        this.display.classList.remove("countdown__display--visible");
        this.display.classList.add("countdown__display--hidden");
      }
      if (!this.completeMessage && this.hideTimerOnComplete === "true") {
        this.block.classList.add("countdown__block--hidden");
      }
      this.timerComplete = true;
    }
  }
};
if (!customElements.get("countdown-timer")) {
  customElements.define("countdown-timer", CountdownTimer);
}

// ../../node_modules/@archetype-themes/next/sections/age-verification-popup/src/scripts/index.js
var AgeVerificationPopup = class extends HTMLElement {
  constructor() {
    super();
    this.cookieName = this.id;
    this.cookie = Cookies.get(this.cookieName);
    this.classes = {
      activeContent: "age-verification-popup__content--active",
      inactiveContent: "age-verification-popup__content--inactive",
      inactiveDeclineContent: "age-verification-popup__decline-content--inactive",
      activeDeclineContent: "age-verification-popup__decline-content--active"
    };
    this.declineButton = this.querySelector("[data-age-verification-popup-decline-button]");
    this.declineContent = this.querySelector("[data-age-verification-popup-decline-content]");
    this.content = this.querySelector("[data-age-verification-popup-content]");
    this.returnButton = this.querySelector("[data-age-verification-popup-return-button]");
    this.exitButton = this.querySelector("[data-age-verification-popup-exit-button]");
    this.backgroundImage = this.querySelector("[data-background-image]");
    this.mobileBackgroundImage = this.querySelector("[data-mobile-background-image]");
    if (Shopify.designMode) {
      document.addEventListener("shopify:section:select", (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) {
          this.init();
        }
      });
      document.addEventListener("shopify:section:load", (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) {
          this.init();
          if (this.dataset.testMode === "true" && this.cookie) {
            Cookies.remove(this.cookieName);
          }
          const secondViewVisited = sessionStorage.getItem(this.id);
          if (!secondViewVisited)
            return;
          this.showDeclineContent();
        }
      });
      document.addEventListener("shopify:section:unload", (event) => {
        if (event.detail.sectionId === this.dataset.sectionId) {
          this.modal.close();
        }
      });
    }
    if (this.cookie && this.dataset.testMode === "false")
      return;
    this.init();
  }
  init() {
    this.modal = new theme.Modals(this.id, "age-verification-popup-modal", {
      closeOffContentClick: false
    });
    if (this.backgroundImage) {
      this.backgroundImage.style.display = "block";
    }
    if (theme.config.bpSmall && this.mobileBackgroundImage) {
      this.mobileBackgroundImage.style.display = "block";
    }
    this.modal.open();
    theme.a11y.lockMobileScrolling(`#${this.id}`, document.querySelector("#MainContent"));
    if (this.declineButton) {
      this.declineButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.showDeclineContent();
        if (Shopify.designMode) {
          sessionStorage.setItem(this.id, "second-view");
        }
      });
    }
    if (this.returnButton) {
      this.returnButton.addEventListener("click", (e) => {
        e.preventDefault();
        this.hideDeclineContent();
        const secondViewVisited = sessionStorage.getItem(this.id);
        if (Shopify.designMode && secondViewVisited) {
          sessionStorage.removeItem(this.id);
        }
      });
    }
    if (this.exitButton) {
      this.exitButton.addEventListener("click", (e) => {
        e.preventDefault();
        if (this.dataset.testMode === "false") {
          Cookies.set(this.cookieName, "entered", { expires: 30, sameSite: "none", secure: true });
        }
        if (this.backgroundImage) {
          this.backgroundImage.style.display = "none";
        }
        if (theme.config.bpSmall && this.mobileBackgroundImage) {
          this.mobileBackgroundImage.style.display = "none";
        }
        this.modal.close();
        theme.a11y.unlockMobileScrolling(`#${this.id}`, document.querySelector("#MainContent"));
      });
    }
  }
  showDeclineContent() {
    this.declineContent.classList.remove(this.classes.inactiveDeclineContent);
    this.declineContent.classList.add(this.classes.activeDeclineContent);
    this.content.classList.add(this.classes.inactiveContent);
    this.content.classList.remove(this.classes.activeContent);
  }
  hideDeclineContent() {
    this.declineContent.classList.add(this.classes.inactiveDeclineContent);
    this.declineContent.classList.remove(this.classes.activeDeclineContent);
    this.content.classList.remove(this.classes.inactiveContent);
    this.content.classList.add(this.classes.activeContent);
  }
};
if (!customElements.get("age-verification-popup")) {
  customElements.define("age-verification-popup", AgeVerificationPopup);
}

// ../../node_modules/@archetype-themes/next/sections/hero-video/src/scripts/index.js
var VideoSection = class extends HTMLElement {
  constructor() {
    super();
    theme.VideoSection = function () {
      const selectors = {
        videoParent: ".video-parent-section"
      };
      function videoSection(container) {
        this.container = container.querySelector('[data-section-type="video-section"]');
        this.sectionId = this.container.getAttribute("data-section-id");
        this.namespace = ".video-" + this.sectionId;
        this.videoObject;
        theme.initWhenVisible({
          element: this.container,
          callback: this.init.bind(this),
          threshold: 500
        });
      }
      videoSection.prototype = Object.assign({}, videoSection.prototype, {
        init: function () {
          const dataDiv = this.container.querySelector(".video-div");
          if (!dataDiv) {
            return;
          }
          const type = dataDiv.dataset.type;
          const videoId = dataDiv.dataset.videoId;
          switch (type) {
            case "youtube":
              this.initYoutubeVideo(videoId);
              break;
            case "vimeo":
              this.initVimeoVideo(videoId);
              break;
            case "mp4":
              this.initMp4Video();
              break;
          }
        },
        initYoutubeVideo: function (videoId) {
          this.videoObject = new theme.YouTube(
            "YouTubeVideo-" + this.sectionId,
            {
              videoId,
              videoParent: selectors.videoParent
            }
          );
        },
        initVimeoVideo: function (videoId) {
          this.videoObject = new theme.VimeoPlayer(
            "Vimeo-" + this.sectionId,
            videoId,
            {
              videoParent: selectors.videoParent
            }
          );
        },
        initMp4Video: function () {
          const mp4Video = "Mp4Video-" + this.sectionId;
          const mp4Div = document.getElementById(mp4Video);
          const parent = mp4Div.closest(selectors.videoParent);
          if (mp4Div) {
            parent.classList.add("loaded");
            const playPromise = document.querySelector(`#${mp4Video}`).play();
            if (playPromise !== void 0) {
              playPromise.then(function () {
              }).catch(function () {
                mp4Div.setAttribute("controls", "");
                parent.classList.add("video-interactable");
              });
            }
          }
        },
        onUnload: function () {
          if (this.videoObject && typeof this.videoObject.destroy === "function") {
            this.videoObject.destroy();
          }
        }
      });
      return videoSection;
    }();
  }
  connectedCallback() {
    this.videoSection = new theme.VideoSection(this);
  }
  disconnectedCallback() {
    this.videoSection.onUnload();
  }
};
if (!customElements.get("video-section")) {
  customElements.define("video-section", VideoSection);
}

/*============================================================================
   HotSpots
 ==============================================================================*/
class HotSpots extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.buttons = this.querySelectorAll("[data-button]");
    this.hotspotBlocks = this.querySelectorAll("[data-hotspot-block]");
    this.blockContainer = this.querySelector("[data-block-container]");
    this.colorImages = this.querySelectorAll(".grid-product__color-image");
    this.colorSwatches = this.querySelectorAll(".color-swatch--with-image");

    this._bindEvents();
    this._setupQuickShop();

    if (this.colorImages.length) {
      this._colorSwatchHovering();
    }
  }

  _colorSwatchHovering() {
    this.colorSwatches.forEach((swatch) => {
      swatch.addEventListener(
        "mouseenter",
        function () {
          this._setActiveColorImage(swatch);
        }.bind(this)
      );

      swatch.addEventListener(
        "touchstart",
        function (evt) {
          evt.preventDefault();
          this._setActiveColorImage(swatch);
        }.bind(this),
        { passive: true }
      );

      swatch.addEventListener(
        "mouseleave",
        function () {
          this._removeActiveColorImage(swatch);
        }.bind(this)
      );
    });
  }

  _setActiveColorImage(swatch) {
    var id = swatch.dataset.variantId;
    var image = swatch.dataset.variantImage;

    // Unset all active swatch images
    this.colorImages.forEach((el) => {
      el.classList.remove("is-active");
    });

    // Unset all active swatches
    this.colorSwatches.forEach((el) => {
      el.classList.remove("is-active");
    });

    // Set active image and swatch
    var imageEl = this.el.querySelector(`.grid-product__color-image--${id}`);
    imageEl.style.backgroundImage = `url(${image})`;
    imageEl.classList.add("is-active");
    swatch.classList.add("is-active");

    // Update product grid item href with variant URL
    var variantUrl = swatch.dataset.url;
    var gridItem = swatch.closest(".grid-item__link");

    if (gridItem) gridItem.setAttribute("href", variantUrl);
  }

  _removeActiveColorImage(swatch) {
    const id = swatch.dataset.variantId;
    this.querySelector(`.grid-product__color-image--${id}`).classList.remove(
      "is-active"
    );
  }

  /* Setup event listeners */
  _bindEvents() {
    this.buttons.forEach((button) => {
      const id = button.dataset.button;

      button.on("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        this._showContent(id);
      });
    });

    // Display active hotspot block on theme editor select
    document.addEventListener("shopify:block:select", (e) => {
      const blockId = e.detail.blockId;
      this._showContent(`${blockId}`);
    });
  }

  /* Toggle sidebar content */
  _showContent(id) {
    // Hide all hotspotBlock
    // Show the hotspotBlock with the id
    this.hotspotBlocks.forEach((block) => {
      if (block.dataset.hotspotBlock === id) {
        block.classList.add("is-active");
      } else {
        block.classList.remove("is-active");
      }
    });
  }

  _setupQuickShop() {
    if (this.querySelectorAll('[data-block-type="product"]').length > 0) {
      // Ensure we are utilizing the right version of QuickShop based off of theme
      if (typeof theme.QuickShop === "function") {
        new theme.QuickShop(this.blockContainer);
      } else if (typeof theme.initQuickShop === "function") {
        theme.initQuickShop();
      }

      if (typeof theme.QuickAdd === "function") {
        new theme.QuickAdd(this.blockContainer);
      }
    }
  }
}
if (!customElements.get("hot-spots")) {
  customElements.define("hot-spots", HotSpots);
}

/*============================================================================
    ProductRecommendations
  ==============================================================================*/
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.url = this.dataset.url;
    this.intent = this.dataset.intent;
    this.placeholder = this.querySelector(
      ".product-recommendations-placeholder"
    );
    this.productResults = this.querySelector(".grid-product");
    this.sectionId = this.dataset.sectionId;
    this.blockId = this.dataset.blockId;

    document.addEventListener("recommendations:loaded", (e) => {
      this.colorImages = this.el.querySelectorAll(
        ".grid-product__color-image"
      );
      if (this.colorImages.length) {
        this.swatches = this.el.querySelectorAll(".color-swatch--with-image");
        this.colorSwatchHovering();
      }
    });
  }

  connectedCallback() {
    fetch(this.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement("div");
        html.innerHTML = text;
        const recommendations = html.querySelector(
          ".product-recommendations"
        );

        if (!recommendations) {
          this.el.classList.add("hide");
          if (AOS) {
            AOS.refreshHard();
          }
          return;
        }

        this.placeholder.innerHTML = "";
        this.placeholder.innerHTML = recommendations.innerHTML;

        theme.reinitProductGridItem(this.el);

        this.slideshow = this.querySelector("[data-slideshow]");

        if (this.slideshow) {
          this.setupSlider();
        }

        document.dispatchEvent(
          new CustomEvent("recommendations:loaded", {
            detail: {
              section: this.el,
              intent: this.intent,
            },
          })
        );
      })
      .catch((e) => {
        console.error(e);
      });
  }

  setupSlider() {
    const controlType = this.slideshow.dataset.controls;
    const perSlide = Number.parseFloat(this.slideshow.dataset.perSlide);
    const count = Number.parseFloat(this.slideshow.dataset.count);

    let prevNextButtons = false;
    let pageDots = true;

    if (controlType === "arrows") {
      pageDots = false;
      prevNextButtons = true;
    }

    if (perSlide < count) {
      this.flickity = new theme.Slideshow(this.slideshow, {
        prevNextButtons,
        pageDots,
        adaptiveHeight: true,
        wrapAround: false,
      });
    }
  }

  colorSwatchHovering() {
    this.swatches.forEach((swatch) => {
      swatch.addEventListener(
        "mouseenter",
        function () {
          this.setActiveColorImage(swatch);
        }.bind(this)
      );

      swatch.addEventListener(
        "touchstart",
        function (evt) {
          evt.preventDefault();
          this.setActiveColorImage(swatch);
        }.bind(this),
        { passive: true }
      );

      swatch.addEventListener(
        "mouseleave",
        function () {
          this.removeActiveColorImage(swatch);
        }.bind(this)
      );
    });
  }

  setActiveColorImage(swatch) {
    const id = swatch.dataset.variantId;
    const image = swatch.dataset.variantImage;

    // Unset all active swatch images
    this.colorImages.forEach((el) => {
      el.classList.remove("is-active");
    });

    // Unset all active swatches
    this.swatches.forEach((el) => {
      el.classList.remove("is-active");
    });

    // Set active image and swatch
    const imageEl = this.el.querySelector(
      `.grid-product__color-image--${id}`
    );

    imageEl.style.backgroundImage = `url(${image})`;
    imageEl.classList.add("is-active");
    swatch.classList.add("is-active");

    // Update product grid item href with variant URL
    const variantUrl = swatch.dataset.url;
    const gridItem = swatch.closest(".grid-item__link");
    gridItem.setAttribute("href", variantUrl);
  }

  removeActiveColorImage(swatch) {
    const id = swatch.dataset.variantId;
    this.el
      .querySelector(`.grid-product__color-image--${id}`)
      .classList.remove("is-active");
  }
}
if (!customElements.get("product-recommendations")) {
  customElements.define("product-recommendations", ProductRecommendations);
}

class LazySection extends HTMLElement {
  static sectionsToFetch = [];

  constructor() {
    super();

    this.section = this.closest('section')?.id || this.closest('[id]').id;
    this.section = this.section?.replace('shopify-section-', '');

    this.trigger = this.dataset.triggerEvent || 'intersection-observer';
    this.targetSelector = this.dataset.triggerTarget || 'body';

    this.boundHandleMouseover = this.handleMouseover.bind(this);
    this.boundHandleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    const targetElement = document.querySelector(this.targetSelector);

    // Different triggers based on data-trigger attribute
    if (this.trigger === 'mouseover') {
      if (screen.width < 990) return;

      targetElement.addEventListener('mouseover', this.boundHandleMouseover);
    } else if (this.trigger === 'click') {
      targetElement.addEventListener('click', this.boundHandleClick);
    } else {
      // Default to intersection observer
      new IntersectionObserver(this.handleIntersection.bind(this), { rootMargin: '200px 0px' }).observe(this);
    }
  }

  // Handler for intersection-observer trigger
  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.fetchSections();
  }

  // Handler for mouseover trigger
  handleMouseover() {
    // Remove trigger once added to sectionsToFetch
    this.removeTrigger();
    this.fetchSections();
  }

  // Handler for click trigger
  handleClick() {
    // Remove trigger once added to sectionsToFetch
    this.removeTrigger();
    this.fetchSections();
  }

  // Common function for fetching sections
  fetchSections() {
    LazySection.sectionsToFetch.push(this.section);
    const sectionsToFetchBatch = LazySection.sectionsToFetch.length == 5 ? LazySection.sectionsToFetch.splice(0, 5) : LazySection.sectionsToFetch;

    // Check if there is an ongoing network request
    if (LazySection.abortController) {
      LazySection.abortController.abort('Section list updated, cancelling request.');
    }

    LazySection.abortController = sectionsToFetchBatch.length < 5 && new AbortController();

    fetch(window.location.pathname + '?sections=' + sectionsToFetchBatch.join(','), LazySection.abortController.signal ? { signal: LazySection.abortController.signal } : {})
      .then((response) => response.json())
      .then((json) => {
        for (const [key, value] of Object.entries(json)) {
          const sectionContent = new DOMParser().parseFromString(value, 'text/html').getElementById('shopify-section-' + key);

          if (sectionContent && sectionContent.innerHTML.trim().length) {
            const section = document.getElementById('shopify-section-' + key);
            section.innerHTML = sectionContent.innerHTML;

            // Reinject scripts
            section.querySelectorAll('script').forEach((oldScriptTag) => {
              const newScriptTag = document.createElement('script');
              Array.from(oldScriptTag.attributes).forEach((attribute) => {
                newScriptTag.setAttribute(attribute.name, attribute.value);
              });
              newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
              oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
            });

            const collectionContainer = section.querySelector('[data-section-type=collection-template]');
            if (collectionContainer) {
              new theme.Collection(collectionContainer);
            }

            const recentlyViewedContainer = section.querySelector('[data-section-type=recently-viewed]');
            if (recentlyViewedContainer && typeof theme.RecentlyViewed === 'function') {
              new theme.RecentlyViewed(recentlyViewedContainer);
            }
          }
        }

        if (sectionsToFetchBatch.length < 5) LazySection.sectionsToFetch = [];
      })
      .catch((e) => {
        console.warn(e);
      });
  }

  // Remove trigger based on data-target attribute
  removeTrigger() {
    const targetElement = document.querySelector(this.targetSelector);

    if (targetElement) {
      targetElement.removeEventListener('mouseover', this.boundHandleMouseover);
      targetElement.removeEventListener('click', this.boundHandleClick);
    }
  }
}
if (!customElements.get('lazy-section')) {
  customElements.define('lazy-section', LazySection);
}
/*============================================================================
  ToolTip
==============================================================================*/

class ToolTip extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.inner = this.querySelector("[data-tool-tip-inner]");
    this.closeButton = this.querySelector("[data-tool-tip-close]");
    this.toolTipContent = this.querySelector("[data-tool-tip-content]");
    this.toolTipTitle = this.querySelector("[data-tool-tip-title]");

    this.triggers = document.querySelectorAll("[data-tool-tip-trigger]");

    document.addEventListener("tooltip:open", (e) => {
      this._open(e.detail.context, e.detail.content);
    });
  }

  _open(context, insertedHtml) {
    this.toolTipContent.innerHTML = insertedHtml;

    // Ensure we set a title for product availability
    if (context != "store-availability") {
      this.toolTipTitle.remove();
    }

    this._lockScrolling();

    if (this.closeButton) {
      this.closeButton.on("click" + ".tooltip-close", () => {
        this._close();
      });
    }

    document.documentElement.on("click" + ".tooltip-outerclick", (event) => {
      if (
        this.el.dataset.toolTipOpen === "true" &&
        !this.inner.contains(event.target)
      )
        this._close();
    });

    document.documentElement.on("keydown" + ".tooltip-esc", (event) => {
      if (event.code === "Escape") this._close();
    });

    this.el.dataset.toolTipOpen = true;
    this.el.dataset.toolTip = context;
  }

  _close() {
    this.toolTipContent.innerHTML = "";
    this.el.dataset.toolTipOpen = "false";
    this.el.dataset.toolTip = "";

    this._unlockScrolling();

    this.closeButton.off("click" + ".tooltip-close");
    document.documentElement.off("click" + ".tooltip-outerclick");
    document.documentElement.off("keydown" + ".tooltip-esc");
  }

  _lockScrolling() {
    theme.a11y.trapFocus({
      container: this.el,
      namespace: "tooltip_focus",
    });

    theme.a11y.lockMobileScrolling();
    document.documentElement.classList.add("modal-open");
  }

  _unlockScrolling() {
    theme.a11y.removeTrapFocus({
      container: this.el,
      namespace: "tooltip_focus",
    });

    theme.a11y.unlockMobileScrolling();
    document.documentElement.classList.remove("modal-open");
  }
}
if (!customElements.get("tool-tip")) {
  customElements.define("tool-tip", ToolTip);
}

/*============================================================================
 ToolTipTrigger
==============================================================================*/

class ToolTipTrigger extends HTMLElement {
  constructor() {
    super();
    this.el = this;
    this.toolTipContent = this.querySelector("[data-tool-tip-content]");
    this.init();
  }

  init() {
    const toolTipOpen = new CustomEvent("tooltip:open", {
      detail: {
        context: this.dataset.toolTip,
        content: this.toolTipContent.innerHTML,
      },
      bubbles: true,
    });

    this.el.addEventListener("click", (e) => {
      e.stopPropagation();
      this.dispatchEvent(toolTipOpen);
    });
  }
}
if (!customElements.get("tool-tip-trigger")) {
  customElements.define("tool-tip-trigger", ToolTipTrigger);
}

/*============================================================================
  NewsletterReminder
==============================================================================*/

class NewsletterReminder extends HTMLElement {
  constructor() {
    super();
    this.closeBtn = this.querySelector("[data-close-button]");
    this.popupTrigger = this.querySelector("[data-message]");

    this.id = this.dataset.sectionId;
    this.newsletterId = `NewsletterPopup-${this.id}`;
    this.cookie = Cookies.get(`newsletter-${this.id}`);
    this.cookieName = `newsletter-${this.id}`;
    this.secondsBeforeShow = this.dataset.delaySeconds;
    this.expiry = Number.parseInt(this.dataset.delayDays);
    this.modal = new theme.Modals(
      `NewsletterPopup-${this.newsletterId}`,
      "newsletter-popup-modal"
    );

    this.init();
  }

  init() {
    document.addEventListener("shopify:block:select", (evt) => {
      if (evt.detail.sectionId === this.id) {
        this.show(0, true);
      }
    });

    document.addEventListener("shopify:block:deselect", (evt) => {
      if (evt.detail.sectionId === this.id) {
        this.hide();
      }
    });

    document.addEventListener(`modalOpen.${this.newsletterId}`, () =>
      this.hide()
    );
    document.addEventListener(`modalClose.${this.newsletterId}`, () =>
      this.show()
    );
    document.addEventListener(`newsletter:openReminder`, () => this.show(0));

    this.closeBtn.addEventListener("click", () => {
      this.hide();
      Cookies.set(this.cookieName, "opened", {
        path: "/",
        expires: this.expiry,
      });
    });

    this.popupTrigger.addEventListener("click", () => {
      const reminderOpen = new CustomEvent("reminder:openNewsletter", {
        bubbles: true,
      });
      this.dispatchEvent(reminderOpen);

      this.hide();
    });
  }

  show(time = this.secondsBeforeShow, forceOpen = false) {
    const reminderAppeared =
      sessionStorage.getItem("reminderAppeared") === "true";

    if (!reminderAppeared) {
      setTimeout(() => {
        this.dataset.enabled = "true";
        sessionStorage.setItem("reminderAppeared", true);
      }, time * 1000);
    }
  }

  hide() {
    this.dataset.enabled = "false";
  }
}
if (!customElements.get("newsletter-reminder")) {
  customElements.define("newsletter-reminder", NewsletterReminder);
}

/*============================================================================
  ParallaxImage
==============================================================================*/

class ParallaxImage extends HTMLElement {
  constructor() {
    super();
    this.parallaxImage = this.querySelector("[data-parallax-image]");
    this.windowInnerHeight = window.innerHeight;
    this.isActive = false;
    this.timeout = null;
    this.directionMap = {
      right: 0,
      top: 90,
      left: 180,
      bottom: 270,
    };
    this.directionMultipliers = {
      0: [1, 0],
      90: [0, -1],
      180: [-1, 0],
      270: [0, 1],
    };

    this.init();
    window.addEventListener("scroll", () => this.scrollHandler());
  }

  getParallaxInfo() {
    const { width, height, top } = this.parallaxImage.getBoundingClientRect();
    let element = this.parallaxImage;
    let multipliers;
    let { angle, movement } = element.dataset;

    let movementPixels =
      angle === "top"
        ? Math.ceil(height * (Number.parseFloat(movement) / 100))
        : Math.ceil(width * (Number.parseFloat(movement) / 100));

    // angle has shorthands "top", "left", "bottom" and "right"
    // nullish coalescing. using `||` here would fail for `0`
    angle = this.directionMap[angle] ?? Number.parseFloat(angle);

    // fallback if undefined
    // NaN is the only value that doesn't equal itself
    if (Number.isNaN(angle)) angle = 270; // move to bottom (default parallax effect)
    if (Number.isNaN(movementPixels)) movementPixels = 100; // 100px

    // check if angle is located in top half and/or left half
    angle %= 360;
    if (angle < 0) angle += 360;

    const toLeft = angle > 90 && angle < 270;
    const toTop = angle < 180;

    element.style[toLeft ? "left" : "right"] = 0;
    element.style[toTop ? "top" : "bottom"] = 0;

    // if it's not a perfectly horizontal or vertical movement, get cos and sin
    if (angle % 90) {
      const radians = (angle * Math.PI) / 180;
      multipliers = [Math.cos(radians), Math.sin(radians) * -1]; // only sin has to be inverted
    } else {
      multipliers = this.directionMultipliers[angle];
    }

    // increase width and height according to movement and multipliers
    if (multipliers[0])
      element.style.width = `calc(100% + ${movementPixels * Math.abs(multipliers[0])
        }px)`;
    if (multipliers[1])
      element.style.height = `calc(100% + ${movementPixels * Math.abs(multipliers[1])
        }px)`;

    return {
      element,
      movementPixels,
      multipliers,
      top,
      height,
    };
  }

  init() {
    const { element, movementPixels, multipliers, top, height } =
      this.getParallaxInfo();

    const scrolledInContainer = this.windowInnerHeight - top;
    const scrollArea = this.windowInnerHeight + height;
    const progress = scrolledInContainer / scrollArea;

    if (progress > -0.1 && progress < 1.1) {
      const position = Math.min(Math.max(progress, 0), 1) * movementPixels;
      element.style.transform = `translate3d(${position * multipliers[0]
        }px, ${position * multipliers[1]}px, 0)`;
    }

    if (this.isActive) requestAnimationFrame(this.init.bind(this));
  }

  scrollHandler() {
    if (this.isActive) {
      clearTimeout(this.timeout);
    } else {
      this.isActive = true;
      requestAnimationFrame(this.init.bind(this));
    }

    this.timeout = setTimeout(() => (this.isActive = false), 20);
  }
}
if (!customElements.get("parallax-image")) {
  customElements.define("parallax-image", ParallaxImage);
}

/*============================================================================
PredictiveSearch
==============================================================================*/

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.enabled = this.getAttribute("data-enabled");
    this.context = this.getAttribute("data-context");
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector("#predictive-search");
    this.closeBtn = this.querySelector(".btn--close-search");
    this.screen = this.querySelector("[data-screen]");
    this.SearchModal = this.closest("#SearchModal") || null;

    // Open events
    document.addEventListener("predictive-search:open", (e) => {
      if (e.detail.context !== this.context) return;
      this.classList.add("is-active");

      // Wait for opening events to finish then apply focus
      setTimeout(() => {
        this.input.focus();
      }, 100);

      document.body.classList.add("predictive-overflow-hidden");
    });

    // listen for class change of 'modal--is-active on this.SearchModal
    if (this.SearchModal) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === "class") {
            const modalClass = mutation.target.className;
            if (modalClass.indexOf("modal--is-active") > -1) {
              setTimeout(() => {
                this.input.focus();
              }, 100);
            }
          }
        });
      });

      observer.observe(this.SearchModal, {
        attributes: true,
      });
    }

    if (this.enabled === "false") return;

    // On typing
    this.input.addEventListener("keydown", () => {
      this.classList.add("is-active");
    });

    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    // Close events
    document.addEventListener("predictive-search:close", () => {
      this.close();
    });
    document.addEventListener("keydown", (event) => {
      if (event.keyCode === 27) this.close();
    });
    this.closeBtn.addEventListener("click", (e) => {
      e.preventDefault();
      this.close();
    });
    this.screen.addEventListener("click", () => {
      this.close();
    });
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) return;

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    const searchObj = {
      q: searchTerm,
      "resources[limit]": 3,
      "resources[limit_scope]": "each",
      "resources[options][unavailable_products]": "last",
    };

    const params = this.paramUrl(searchObj);

    fetch(
      `${theme.routes.predictiveSearch}?${params}&section_id=search-results`
    )
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, "text/html")
          .querySelector("#shopify-section-search-results").innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();

        AOS.refreshHard();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = "block";
  }

  close() {
    this.predictiveSearchResults.style.display = "none";
    this.predictiveSearchResults.innerHTML = "";
    this.classList.remove("is-active");
    document.body.classList.remove("predictive-overflow-hidden");

    document.dispatchEvent(new CustomEvent("predictive-search:close-all"));
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  paramUrl(obj) {
    return Object.keys(obj)
      .map(function (key) {
        return key + "=" + encodeURIComponent(obj[key]);
      })
      .join("&");
  }
}
if (!customElements.get("predictive-search")) {
  customElements.define("predictive-search", PredictiveSearch);
}

/*============================================================================
ImageElement
==============================================================================*/

class ImageElement extends HTMLElement {
  constructor() {
    super();

    this.init();
  }

  init() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;

      this.removeAnimations();

      observer.unobserve(this);
    };

    // Set an IntersectionObserver to check if the image is nearly in the viewport
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }

  removeAnimations() {
    // Find the closest image-wrap and remove the animation (fix for streamline image-wrap shimmer)
    const imageWrap = this.closest(".image-wrap");
    const skrimWrap = this.closest(".skrim__link");

    if (imageWrap) {
      imageWrap.classList.add("loaded");
    }

    if (skrimWrap) {
      skrimWrap.classList.add("loaded");
    }
  }
}
if (!customElements.get("image-element")) {
  customElements.define("image-element", ImageElement);
}

class RecipientForm extends HTMLElement {
  constructor() {
    super();
    this.checkboxInput = this.querySelector(
      `#Recipient-Checkbox-${this.dataset.sectionId}`
    );
    this.emailInput = this.querySelector(
      `#Recipient-email-${this.dataset.sectionId}`
    );
    this.nameInput = this.querySelector(
      `#Recipient-name-${this.dataset.sectionId}`
    );
    this.messageInput = this.querySelector(
      `#Recipient-message-${this.dataset.sectionId}`
    );
    this.addEventListener("change", () => this.onChange());
    this.recipientFields = this.querySelector(".recipient-fields");

    this.checkboxInput.addEventListener("change", () => {
      this.recipientFields.style.display = this.checkboxInput.checked
        ? "block"
        : "none";
    });
  }

  connectedCallback() {
    document.addEventListener("ajaxProduct:error", (event) => {
      const productVariantID =
        event.target.querySelector('[name="id"]').value;
      if (productVariantID === this.dataset.productVariantId) {
        this.displayErrorMessage(event.detail.errorMessage);
      }
    });

    document.addEventListener("ajaxProduct:added", (event) => {
      const productVariantID =
        event.target.querySelector('[name="id"]').value;
      if (productVariantID === this.dataset.productVariantId) {
        this.clearInputFields();
        this.clearErrorMessage();
      }
    });
  }

  onChange() {
    if (!this.checkboxInput.checked) {
      this.clearInputFields();
      this.clearErrorMessage();
    }
  }

  clearInputFields() {
    this.querySelectorAll(".field__input").forEach((el) => (el.value = ""));
  }

  displayErrorMessage(body) {
    this.clearErrorMessage();
    if (body) {
      return Object.entries(body).forEach(([key, value]) => {
        const inputElement = this[`${key}Input`];
        if (!inputElement) return;

        inputElement.setAttribute("aria-invalid", true);
        inputElement.classList.add("field__input--error");
      });
    }
  }

  clearErrorMessage() {
    this.querySelectorAll(".field__input").forEach((inputElement) => {
      inputElement.setAttribute("aria-invalid", false);
      inputElement.removeAttribute("aria-describedby");
      inputElement.classList.remove("field__input--error");
    });
  }
}
if (!customElements.get("recipient-form")) {
  customElements.define("recipient-form", RecipientForm);
}

// Custom filters (filters in between products) show-more/show-less functionality ---start
class ShowMoreButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.toggleFilters);
  }

  toggleFilters() {
    const parentList = this.closest('ul');
    if (!parentList) return;

    const hiddenFilters = parentList.querySelectorAll('li');

    let isExpanded = false;

    hiddenFilters.forEach((filter, index) => {
      if (index >= 5) {
        filter.classList.toggle('hide-filter');
        filter.style.display = filter.classList.contains('hide-filter') ? 'none' : 'block';
        if (filter.style.display === 'block') {
          isExpanded = true;
        }
      }
    });

    this.textContent = isExpanded ? '- Show Less' : '+ Show More';
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.toggleFilters);
  }
}
if (!customElements.get('show-more-button')) {
  customElements.define('show-more-button', ShowMoreButton);
}
// Custom filters (filters in between products) show-more/show-less functionality ---end